import PropTypes from 'prop-types';
import React, { useEffect, useMemo, useState } from 'react';
import CommentCard from 'containers/cards/Comment';
import Page from 'containers/Page';
import { useApolloClient, useQuery } from '@apollo/client';
import { useRouter } from 'found';
import { GET_PROFILE_INFO } from '../schema/apolloQueries/commonQueries';
import { GET_NOTIFICATIONS_DETAILS } from '../schema/apolloQueries/notificationsQueries';

const CommentPage = ({ viewer }) => {
  const {
    // router,
    match: {
      params: { nodeId },
    },
  } = useRouter();

  const client = useApolloClient();
  // const [deleting, setDeleting] = useState(false);

  const profileData = client.readQuery({
    query: GET_PROFILE_INFO,
  });
  const { data } = useQuery(GET_NOTIFICATIONS_DETAILS, {
    variables: {
      modelId: nodeId,
      modelName: 'DISCUSSION',
    },
  });
  const [edge, setEdge] = useState(null);
  useEffect(() => {
    if (data?.getEventFeedById) {
      setEdge(data.getEventFeedById);
    }

  }, [data]);
  const setLikeOrUnlike = () => {
    setEdge(prevEdge => {
      let newObj = { ...prevEdge };
      newObj = {
        ...newObj,
        feedInfo: { ...newObj.feedInfo, liked: !newObj.feedInfo.liked, likeCount: !newObj.feedInfo.liked ? newObj.feedInfo.likeCount + 1 : newObj.feedInfo.likeCount - 1 },
      };
      return newObj;
    });
  };
  const setEditComment = (editingComment) => {
    setEdge(prevEdge => {
      let newObj = { ...prevEdge };
      newObj = {
        ...newObj,
        commentInfo: { ...newObj.commentInfo, body: editingComment },
      };
      return newObj;
    });
  };

  const setCommentCount = () => {
    setEdge(prevEdge => {
      let newObj = { ...prevEdge };
      newObj = {
        ...newObj,
        feedInfo: { ...newObj.feedInfo, commentCount: newObj.feedInfo.commentCount + 1 },
      };
      return newObj;
    });
  };

  // const { community, event, medium, parent, party, product, review } = comment;
  return (
    <Page
      backLink={useMemo(() => {
        return {
          href: '/notifications',
          label: 'Notifications',
        };
      }, [])}
      // backLink={useMemo(() => {
      //     if (parent) {
      //       return {
      //         href: `/comments/${parent.id}`,
      //         label: `${parent.person.displayName}'s Comment`,
      //       };
      //     }
      //     if (community) {
      //       return {
      //         href: `/communities/${community.slug}`,
      //         label: community.name,
      //       };
      //     }
      //     if (event) {
      //       return {
      //         href: `/events/${event.slug}`,
      //         label: `${event.community.name} ${event.name}`,
      //       };
      //     }
      //     if (medium) {
      //       return {
      //         href: `/media/${medium.id}`,
      //         label: `${medium.person.displayName}'s Media`,
      //       };
      //     }
      //     if (party) {
      //       return {
      //         href: `/parties/${party.id}`,
      //         label: `${party.host.displayName}'s ${party.event.community.name} ${party.event.name} Party`,
      //       };
      //     }
      //     if (product) {
      //       return {
      //         href: `/products/${product.slug}`,
      //         label: `${product.event.community.name} ${product.name}`,
      //       };
      //     }
      //     if (review) {
      //       return {
      //         href: `/reviews/${review.id}`,
      //         label: `${review.person.displayName}'s ${review.product.event.community.name} ${review.product.name} Review`,
      //       };
      //     }
      //     return null;
      //   }, [community, event, medium, parent, party, product, review])}
      //   loading={deleting}
      title={useMemo(() => {
        const label = 'Comment';
        return profileData?.getProfile?.loggedIn && profileData?.getProfile.personId === data?.getEventFeedById?.personInfo?.id
          ? `Your ${label}`
          : `${data?.getEventFeedById?.personInfo?.displayName || ''}'s ${label}`;
      }, [
        data?.getEventFeedById?.personInfo?.displayName,
        data?.getEventFeedById?.personInfo?.id,
        profileData?.getProfile?.loggedIn,
        profileData?.getProfile?.personId,
      ])}
      trackerData={useMemo(
        () => ({
          edge,
          viewer,
        }),
        [edge, viewer],
      )}
      trackerTitle='Comments > View'
      viewer={profileData?.getProfile}
    >
      {edge && (
        <CommentCard
          comment={edge}
          onLikeOrUnlike={setLikeOrUnlike}
          onEditComment={(editingComment) => {
            setEditComment(editingComment);
          }}
          onDelete={() => {
            setEdge(null);
          }}
          onReplyCount={setCommentCount}
          //     onDelete={useCallback(() => {
          //       let action = 'Delete comment';
          //       let category;
          //       let mutation;
          //       let redirect;
          //       let data;
          //       if (parent) {
          //         action = 'Delete reply';
          //         category = 'Comments';
          //         data = {
          //           comment: parent,
          //           reply: comment,
          //         };
          //         mutation = new DeleteCommentReplyMutation(data);
          //         redirect = `/comments/${parent.id}`;
          //       } else if (community) {
          //         category = 'Communities';
          //         data = {
          //           comment,
          //           community,
          //           viewer,
          //         };
          //         mutation = new DeleteCommunityCommentMutation(data);
          //         redirect = `/communities/${community.slug}`;
          //       } else if (event) {
          //         category = 'Events';
          //         data = {
          //           comment,
          //           event,
          //           viewer,
          //         };
          //         mutation = new DeleteEventCommentMutation(data);
          //         redirect = `/events/${event.slug}`;
          //       } else if (medium) {
          //         category = 'Media';
          //         data = {
          //           comment,
          //           medium,
          //         };
          //         mutation = new DeleteMediumCommentMutation(data);
          //         redirect = `/media/${medium.id}`;
          //       } else if (party) {
          //         category = 'Parties';
          //         data = {
          //           comment,
          //           party,
          //           viewer,
          //         };
          //         mutation = new DeletePartyCommentMutation(data);
          //         redirect = `/parties/${party.id}`;
          //       } else if (product) {
          //         category = 'Products';
          //         data = {
          //           comment,
          //           product,
          //         };
          //         mutation = new DeleteProductCommentMutation(data);
          //         redirect = `/products/${product.slug}`;
          //       } else if (review) {
          //         category = 'Reviews';
          //         data = {
          //           comment,
          //           review,
          //         };
          //         mutation = new DeleteReviewCommentMutation(data);
          //         redirect = `/reviews/${review.id}`;
          //       }
          //       if (mutation && data) {
          //         setDeleting(true);
          //         relay.commitUpdate(mutation, {
          //           onFailure: transaction => {
          //             const { message } = extractTransactionError(transaction);
          //             setDeleting(false);
          //             tracker.trackGoogleAnalyticsException(message, data);
          //           },
          //           onSuccess: () => {
          //             setDeleting(false);
          //             tracker.trackGoogleAnalyticsEvent(category, action, data);
          //             router.push(redirect || '/');
          //           },
          //         });
          //       }
          //     }, [
          //       comment,
          //       community,
          //       event,
          //       medium,
          //       parent,
          //       party,
          //       product,
          //       relay,
          //       review,
          //       router,
          //       viewer,
          //     ])}
          viewer={viewer}
        />
      )}
    </Page>
  );
};

CommentPage.propTypes = {
  router: PropTypes.object.isRequired,
  viewer: PropTypes.object.isRequired,
};

export default CommentPage;
